import { apiFetch } from '@/lib/api';

// Client for the opt-in shell's role-scoped surface snapshot
// (GET /api/v1/me/surfaces, backend PR #119). This is the authoritative,
// server-resolved view of what the caller may manage — including runtime
// founder operator grants, which the synchronous client-side `getVerticalAdminAccess`
// (tenant-role based) cannot see. The gate consults `manageable_verticals` from
// here so a granted founder is admitted with no second role model.
//
// NOTE (coordination): the opt-in shell nav (PR #120) is the other consumer of
// this endpoint. If a shared `useSurfaces` store lands there, fold this into it —
// the endpoint + shape are the stable seam.
export interface SurfaceSnapshot {
  role: 'director' | 'operator' | 'tenant';
  manageable_verticals: string[];
  subscribed_verticals: string[];
  enabled_capabilities: string[];
  permitted_capabilities: string[];
  // The authoritative shell render list — the nav/route surfaces this caller may
  // see (SENSARRA-VERTICAL-TENANT-SURFACE-1). Nav + route guards both gate off
  // this one list so they cannot drift; it is fail-closed backend-side.
  visible_surfaces: string[];
}

export const surfacesApi = {
  getMySurfaces: (): Promise<SurfaceSnapshot> => apiFetch('/api/v1/me/surfaces'),
};
